import { Controller } from "@hotwired/stimulus";

import {
  cycleThemePreference,
  getThemePreference,
  initializeTheme,
  subscribeThemeChanges,
} from "@/modules/theme";

const THEME_LABELS = {
  system: "自动",
  light: "浅色",
  dark: "深色",
};

export default class extends Controller {
  static targets = ["label", "hint"];

  static values = {
    preferences: Array,
  };

  connect() {
    initializeTheme();
    this.update(getThemePreference());
    this.unsubscribe = subscribeThemeChanges(({ preference }) => {
      this.update(preference);
    });
  }

  disconnect() {
    this.unsubscribe?.();
  }

  toggle(event) {
    event.preventDefault();
    cycleThemePreference();
  }

  update(preference) {
    const normalizedPreference = this.preferencesValue.includes(preference)
      ? preference
      : "system";
    const label = THEME_LABELS[normalizedPreference];

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = label;
    }

    if (this.hasHintTarget) {
      this.hintTarget.textContent = `主题：${label}`;
    }

    this.element.dataset.themePreference = normalizedPreference;
    this.element.setAttribute("aria-label", `切换主题，当前${label}`);
    this.element.setAttribute("title", `切换主题，当前${label}`);
  }
}
